bgFieldsDirective = angular.module('bgfields.setting', [])

bgFieldsDirective.directive "bgFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "Section", "Email", ($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, Section, Email) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/bgfields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.sectionId
    sectionElement = angular.element("[data-section-id=#{id}]").find ns.widgetWrapperClass
    scope.section = angular.copy scope.data
    scope.refresh = true
    scope.from_email = attrs.fromEmail

    getNotDestroyedFieldRnd = ->
      fields = []
      _.each scope.section.background_attributes.images_attributes, (field, index) ->
        if !field._destroy
          fields.push index
      if fields.length > 0
        fields[fields.length-1]
      else
        0

    scope.currentField = getNotDestroyedFieldRnd()

    scope.fieldsLength = (fields) ->
      destroyed = _.filter fields, _destroy: true
      fields.length - destroyed.length

    scope.setCurrentImage = ($index) ->
      scope.currentField = $index
      scope.refresh = false
      $timeout ->
        scope.refresh = true

    scope.add = ->
      sectionId = id
      scope.section.background_attributes.images_attributes.push {source_url: ""}
      length = scope.section.background_attributes.images_attributes.length-1
      scope.setCurrentImage length

    scope.remove = ->
      imageId = scope.section.background_attributes.images_attributes[scope.currentField].id
      if imageId
        if scope.from_email
          Email.destoyItem(scope.section, imageId).then ->
            scope.data.background_attributes.images_attributes.splice scope.currentField, 1
            scope.setCurrentImage getNotDestroyedFieldRnd()
        else
          Section.destoyItem(scope.section, imageId).then ->
            scope.data.background_attributes.images_attributes.splice scope.currentField, 1
            scope.setCurrentImage getNotDestroyedFieldRnd()
      else
        scope.data.background_attributes.images_attributes.splice scope.currentField, 1

    listener1 = scope.$watch "section.background_attributes.images_attributes", (newVal, oldVal) ->
      scope.data.background_attributes.images_attributes = newVal
    , true

    scope.$on "$destroy", ->
      listener1()

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/bgfields/bgFields.directive.coffee